import { useMemo } from 'react'
import { aFiltersFind, useAtomValue } from '~/atoms'
import { getClientFind } from '~/lib/map-listing-find'
import type { Client } from '~/models'

export function useClientFind(client: Client) {
  const filtersFind = useAtomValue(aFiltersFind)
  const find = useMemo(
    () => getClientFind(client, filtersFind),
    [client, filtersFind]
  )

  return find
}
